import {defineMessages} from 'react-intl';
import {AddToCartButtonMode} from './IAddToCartButton';

export default defineMessages({
	success: {
		id: 'productView.popup.addedToCart',
		defaultMessage: '<comment>Added to bag</comment><cta>View</cta>',
	},
	error: {
		id: 'common.error.general',
		defaultMessage: 'Oops! Something went wrong.',
	},
	[AddToCartButtonMode.ADD_TO_CART]: {
		id: 'productView.button.addToCart',
		defaultMessage: 'Add to cart',
	},
	[AddToCartButtonMode.BUY_NOW]: {
		id: 'productView.button.buyNow',
		defaultMessage: 'Buy now',
	},
	[AddToCartButtonMode.PREORDER_NOW]: {
		id: 'productView.button.preOrderNow',
		defaultMessage: 'Pre-Order Now'
	},
	quantityError: {
		id: 'productView.button.quantityError',
		defaultMessage: 'You have entered the maximum quantity available for this item'
	},
});
